import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $PageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 100vh;
`;

export const $StepWrapper = styled.div`
  margin-top: ${spacing(16)};
  @media ${media.minWidth.sm} {
    margin-top: unset;
  }
`;
